/* @flow */
import * as React from 'react';
import groupBy from 'lodash/groupBy';
import { Query } from 'react-apollo';
import GET_ADMIN_INTEGRATIONS from 'admin/queries/getAdminIntegrations.gql';

type Props = {
  children: Function,
  fetchPolicy?: ?string,
  organizationUUID: string,
};

function AdminIntegrationsContainer({ children, organizationUUID }: Props) {
  return (
    <Query
      query={GET_ADMIN_INTEGRATIONS}
      variables={{ organizationUUID }}
      refetchQueries={[{ query: GET_ADMIN_INTEGRATIONS, variables: { organizationUUID } }]}>
      {({ loading, error, data }) => {
        if (loading || error) {
          return null;
        }
        const integrations = groupBy(
          data.adminPossibleIntegrations,
          integration => integration.__typename
        );
        return children({
          adminIntegrations: integrations.AdminIntegration,
          partnerIntegrations: integrations.PartnerIntegration,
        });
      }}
    </Query>
  );
}

export default AdminIntegrationsContainer;
